/**
 * Parses a full name string into its components: first name, middle name, and last name.
 *
 * @param {string} fullName - The full name string to parse.
 * @returns {{ firstName: string, middleName: string, lastName: string }} An object containing the first name, middle name, and last name.
 */
export function parseFullName(fullName: string) {
  const nameParts = fullName.trim().split(/\s+/); // Split by any whitespace and trim

  const firstName = nameParts[0] || "";
  const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
  const middleName =
    nameParts.length > 2 ? nameParts.slice(1, nameParts.length - 1).join(" ") : "";

  return { firstName, middleName, lastName };
}
